var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#EBE0D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 26.834H19.8333C18.5447 26.834 17.5 27.8787 17.5 29.1673V37.334C17.5 38.6226 18.5447 39.6673 19.8333 39.6673H36.1667C37.4553 39.6673 38.5 38.6226 38.5 37.334V29.1673C38.5 27.8787 37.4553 26.834 36.1667 26.834Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 26.834V22.1673C22.167 20.6202 22.7816 19.1365 23.8755 18.0425C24.9695 16.9486 26.4532 16.334 28.0003 16.334C29.5474 16.334 31.0312 16.9486 32.1251 18.0425C33.2191 19.1365 33.8337 20.6202 33.8337 22.1673V26.834",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesThree);
export default __webpack_public_path__ + "static/media/features-three.107da19d28b1bcbd5d13339cda0046e3.svg";
export { ForwardRef as ReactComponent };